import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from '../components/Footer';
import {useLocation} from 'react-router-dom';
import axios from 'axios';

const Products = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  const category = queryParameters.get("id");
  const location =useLocation();

  const [products, setproducts] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);



  useEffect(() => {

    if (location.state?.isSearchResult) {
      setproducts(location.state.products);
      setLoading(false);
      return;
    }



    const products = async () => {
      try {
        const response = await axios.post('https://api.welbeing.in/product/get-products/', { sub_id: category });
        if (response.data.status === 'success') {
          setproducts(response.data.data)
        }
        // console.log('Login successful:', response.data);

      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    products();
  }, []);

  return (
    <>
      <Header />
      <main className="main">
        <div className="breadcrumb-wrap" id="breadcrumb-margin">
          <div className="banner" style={{minHeight:'10px'}}>
            <div className="container-lg">
              <div className="breadcrumb-box">
                <div className="heading-box">
                  <h1>products</h1>
                </div>
                <ol className="breadcrumb">
                  <li><a href="/">Home</a></li>
                  <li>
                    <a href="javascript:void(0)"><i data-feather="chevron-right"></i></a>
                  </li>
                  <li className="current"><a href="">Products</a></li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <section className="shop-page">
          <div className="container-lg">
            <div className="row gy-4 g-lg-3 g-xxl-4">
              <div className="col-12">
                <div className="row gy-5 gx-0">
                  <div className="col-12 order-6 order-lg-2">
                    <div className="shop-product">
                      <div className="product-tab-content">
                        <div className="row g-3 g-xl-4 ratio_asos">
                          <iframe name="dummyframe" id="dummyframe" style={{ display: 'none' }}></iframe>

                          {products?.map((product) => (
                            <div
                              className="col-12 col-sm-6 col-md-3 col-lg-2"
                              key={product.p_id}
                            >
                              <div className='intagram-card2 intagram-card h-100 border-lg' style={{border: '1px solid #fff'}}>
                                <div className='img-box after-none border-lg'>
                                  <a href={`singleproduct?id=${product.p_id}`} className='primary-img'>
                                    <img
                                      className='img-fluid'
                                      src={`https://api.welbeing.in/uploads/products/${product.img1}`}
                                      alt={product.name}
                                      onError={(e) => {
                                        e.target.src = "https://api.welbeing.in/uploads/products/no_img.jpg";
                                      }}
                                    />
                                  </a>

                                  <div className='on-hover dark-box-sm'>
                                    <a href={`singleproduct?id=${product.p_id}`} className='content-box bordered-wrap'>
                                      <img
                                        className='img-fluid'
                                        src={`https://api.welbeing.in/uploads/products/${product.img2}`}
                                        alt={product.name}
                                        onError={(e) => {
                                          e.target.src = "https://api.welbeing.in/uploads/products/no_img.jpg";
                                        }}
                                      />
                                    </a>
                                  </div>
                                </div>

                                <div className='content-box mt-2' style={{ fontSize: '16px', padding: '0px 10px' }}>
                                  <a href={`singleproduct?id=${product.p_id}`}>
                                    <h6>{product.item_code}</h6>
                                    <h5 style={{fontWeight: '600'}}>{product.item_name?.length > 20 ? product.item_name.slice(0, 20) + "..." : product.item_name}</h5>
                                    <b className="mt-2" style={{display: 'flex', justifyContent: 'space-between'}}>
                                      <del style={{ color: '#911077' }}> ₹{(parseFloat(product.item_price) + Math.floor(Math.random() * 10) + 1).toFixed(2)}</del>
                                      <span style={{fontSize: '20px'}}>₹{parseFloat(product.item_price).toFixed(2)}</span>
                                    </b>
                                  </a>
                                </div>

                                <form className='cart-form' method='POST' target='dummyframe' style={{padding: '0px 10px'}}>
                                  <div className='product-form-buttons d-flex align-items-center justify-content-between mt-1'>
                                    <input type='hidden' name='id' value={product.p_id} />
                                    <input type='hidden' name='item_code' value={product.item_code} />
                                    <input type='hidden' name='prices' value={product.item_price} />
                                    <input type='hidden' name='weight' value='0' />
                                    <input type='hidden' name='img' value={product.img1} />
                                    <input className='qty-input' type='hidden' name='quantity' value='' />
                                    <a
                                      href={`singleproduct?id=${product.p_id}`}
                                      className='btn btn-solid btn-sm mb-line addtocart-btns w-100'
                                      style={{ padding: '9px', textAlign: 'center', justifyContent: 'center' }}
                                      value='Add to Cart'
                                    >
                                      View<i className='arrow'></i>
                                    </a>
                                  </div>
                                </form>
                                {/* <ul className='option-wrap' style={{ marginTop: '-40px', marginLeft: '15px' }}>
                                  <li>Wishlist button</li>
                                </ul> */}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer/>
      </main>
    </>
  );
}

export default Products;